import { Component, inject, Input } from '@angular/core';
import { Constants } from './../../app.constants';
import { SessionService } from '../../services/session.service';
import { combineLatest, filter, map, take } from 'rxjs';

@Component({
  selector: 'app-disclaimer-links',
  templateUrl: './disclaimer-links.component.html',
  styleUrls: ['./disclaimer-links.component.scss']
})
export class DisclaimerLinksComponent {
  @Input() isSmallFont: boolean = false;
  @Input() isAppFooter: boolean = false;

  private sessionService = inject(SessionService);
  private constants = inject(Constants);
  private constants$ = this.constants.CalOptimaOrgUrlSubject()
    .pipe(map(result => ({
          PortalAccessAgreementUrl: result + this.constants.PortalAccessAgreementPath,
          PortalAccessPolicyUrl: this.constants.PortalAccessPolicyPath,
          CaloptimahealthguidelinesUrl: 'https://caloptimahealth.access.mcg.com/index'
        })),
      take(1));
  /** vm$ = view model. Combines all observables into a single type usable by the UI */
  public vm$ = combineLatest([this.constants$]).pipe(filter(([urls]) => Boolean(urls)), map(([urls]) =>({urls})));

  public get IsLoggedInUser():boolean {
      return this.sessionService.currentPermission != null;
  }
}
